// REV-31: ujednolicenie `item_name` między site_area = b2c i b2b.
// Logika MUSI być identyczna z b2c (PS-1724, web: src/services/analytics/gtm/utils/sanitize-item-name.ts),
// bo tylko ta sama normalizacja gwarantuje, że ten sam item_id wysyła bajt-w-bajt tę samą nazwę
// w obu site_area — inaczej GA4 dalej rozbija jeden produkt na kilka wierszy.
//
// Normalizacja: ujednolica myślniki Unicode do ASCII `-`, redukuje dowolny ciąg białych znaków
// (spacja, tab, NBSP) do pojedynczej spacji i przycina krawędzie.
//
// DASH_LIKE = zakres U+2010..U+2015 (hyphen, non-breaking hyphen, figure/en/em dash, horizontal bar)
// + U+2212 (minus sign); odpowiednik b2c /[‐-―−]/g.
const DASH_LIKE = /[‐-―−]/g;
const WHITESPACE = /\s+/g;

export function sanitizeItemName(value: string): string {
  return value.replace(DASH_LIKE, "-").replace(WHITESPACE, " ").trim();
}
